import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import 'maplibre-gl/dist/maplibre-gl.css';
import './styles/main.css';
import './styles/cardio.css';
import './styles/cardio-v5.css';
import './styles/body.css';
import './styles/health.css';
import './styles/calendar.css';
import './styles/feed.css';
import './styles/section-soon.css';
import './styles/hero-ticker.css';
import './styles/map.css';
import './styles/mobile-nav.css';
import './styles/mobile-modals.css';
import './styles/mobile-home.css';
import './styles/mobile-pages.css';
import './styles/mobile-sheets.css';

import { App } from './App';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element #root not found');

createRoot(rootEl).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
